import { render } from "./Service.vue?vue&type=template&id=7ae401f6&scoped=true"
const script = {}

import "./Service.vue?vue&type=style&index=0&id=7ae401f6&lang=sass&scoped=true"
script.render = render
script.__scopeId = "data-v-7ae401f6"

export default script